import React from 'react';
import { Button, Dimmer, Icon, Loader, Modal, ModalProps } from 'semantic-ui-react';
import LoaderMilkCan from '../Loader';
import { StyledAbortModal, StyledModal, StyledPreviewModal } from './style'

type DialogProps = {
  textSubmit?: string;
  textClose?: string;
  textContent: string | React.ReactElement;
  textHeader: string | React.ReactElement;
  isDialogOpen?: boolean;
  handleClose?: (e?) => void;
  handleSubmit?: (...args) => any;
  size?: 'small' | 'mini' | 'tiny' | 'large' | 'fullscreen';
  isLoading?: boolean;
  type?: 'abort' | 'dialog' | 'preview'
  disableSubmit?: boolean
  onMount?: (...args) => any,
  style?: any
  htmlContent?: any
  hideCloseIcon?: boolean
  noScrollingContent?: boolean,
  heightDialog?: string | number
  contentAutoSize?: boolean,
  minHeight?: string
  typeButton?: 'button' | 'submit'
  renderActions?: () => React.ReactNode
  heightContent?: string
  actionContent?: React.ReactNode
}

type DialogPropsCombined = DialogProps & ModalProps

const Dialog: React.FunctionComponent<DialogPropsCombined> = (props) => {
  const {
    size,
    isDialogOpen,
    handleSubmit,
    handleClose,
    textSubmit,
    textClose,
    isLoading,
    minHeight,
    disableSubmit,
    textContent,
    textHeader,
    htmlContent,
    type,
    onMount,
    hideCloseIcon,
    heightDialog,
    style,
    ...modalProps
  } = props;

  function renderModalActions() {
    return <>
      {textSubmit && <Button
        disabled={Boolean(disableSubmit || isLoading)}
        loading={isLoading}
        positive onClick={() => handleSubmit()}
        type={props.typeButton || 'button'}
      >
        {textSubmit}
      </Button>
      }
      {textClose && <Button negative onClick={() => handleClose()}>
        {textClose}
      </Button>
      }
    </>
  }

  function renderDialog() {
    const hasActions = textClose || textSubmit;
    return <StyledModal
      onClose={() => handleClose()}
      size={size}
      open={isDialogOpen}
      onMount={onMount}
      style={style}
      {...modalProps}
      $minHeight={minHeight}
      closeOnDimmerClick={false}
      $actionContent={Boolean(props.actionContent)}
    >
      <Modal.Header>
        <div className='header-title'>{textHeader}</div>
        {!hideCloseIcon && <Icon onClick={() => handleClose()} className='header-close-icon' name='close' />}
      </Modal.Header>
      <Modal.Content scrolling={!props.noScrollingContent}>
        <Dimmer inverted active={isLoading}>
          <LoaderMilkCan isLoading={isLoading} />
        </Dimmer>
        {typeof(textContent) === 'string' ? <p>{textContent}</p> : textContent}
      </Modal.Content>
      {hasActions && <Modal.Actions>
        {props.actionContent && props.actionContent}
        {props.renderActions ? props.renderActions() : renderModalActions()}
      </Modal.Actions>}
    </StyledModal>
  }

  function renderPreviewModal() {
    return <StyledPreviewModal
      onClose={() => handleClose()}
      size={size}
      open={isDialogOpen}
      onMount={onMount}
      style={style}
      {...modalProps}
      height={heightDialog}
      closeOnDimmerClick={false}
      $heightContent={props.heightContent}
    >
      <Modal.Header>
        <div className='header-title'>{textHeader}</div>
        <Icon onClick={() => handleClose()} className='header-close-icon' name='close' />
      </Modal.Header>
      <Modal.Content scrolling={!props.noScrollingContent}>
        <Dimmer inverted active={isLoading}>
          <Loader active={isLoading} />
        </Dimmer>
        {textContent}
      </Modal.Content>
    </StyledPreviewModal>
  }

  function renderAbortModal() {
    return <StyledAbortModal
      open={Boolean(isDialogOpen)}
      onClose={(e) => handleClose(e)}
      size={props.size || 'tiny'}
      style={style}
      $textAlign={!htmlContent ? 'center' : 'left'}
      {...modalProps}
      closeOnDimmerClick={false}
    >
      <Modal.Header>
        <div className='header-title'>{textHeader}</div>
        <Icon onClick={() => handleClose()} className='header-close-icon' name='close' />
      </Modal.Header>
      <Modal.Content>
        <Dimmer inverted active={isLoading}>
          <LoaderMilkCan isLoading={isLoading} />
        </Dimmer>
        <div>{textContent}</div>
      </Modal.Content>
      <Modal.Actions>
        {textSubmit && <Button
          disabled={Boolean(disableSubmit || isLoading)}
          onClick={() => handleSubmit()}
          positive
          loading={isLoading}
        >
          {textSubmit}
        </Button>
        }
        {textClose && <Button onClick={() => handleClose()} negative>
          {textClose}
        </Button>
        }
      </Modal.Actions>
    </StyledAbortModal>
  }

  function renderModalBasedOnType() {
    switch (type) {
      case 'abort':
        return renderAbortModal()
      case 'dialog':
        return renderDialog()
      case 'preview':
        return renderPreviewModal()
      default:
        return renderDialog()
    }
  }

  return renderModalBasedOnType()
};

export default Dialog;
